export default "__VITE_ASSET__CtNMi0n2__"